// extracted by mini-css-extract-plugin
export default {"logo":"Logo-module__logo--uKM0m"};